import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GarbageCollectorShedulerSettingsFormComponent } from '../garbage-collector-sheduler-settings-form/garbage-collector-sheduler-settings-form.component';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-garbage-collector-sheduler-settings',
    templateUrl: './garbage-collector-sheduler-settings.component.html',
    styleUrls: ['./garbage-collector-sheduler-settings.component.scss']
})
export class GarbageCollectorShedulerSettingsComponent implements OnInit {
    @ViewChild(GarbageCollectorShedulerSettingsFormComponent)
    formComponent: GarbageCollectorShedulerSettingsFormComponent;

    @Input()
    settings: ISchedulerSettings;

    get formGroup(): FormGroup {
        return _.get(this, 'formComponent.formGroup');
    }

    get isFormInvalid(): boolean {
        return _.get(this.formGroup, 'invalid', false);
    }

    get formValue(): any {
        return _.get(this.formGroup, 'value');
    }

    constructor(private dialogRef: MatDialogRef<GarbageCollectorShedulerSettingsComponent>) {}

    ngOnInit(): void {}

    save() {
        this.settings.initWithJSON(
            _.pick(this.formGroup.value, [
                'garbageCollectorSchedulerIntervalMin',
                'isGarbageCollectorSchedulerActive'
            ]) as any
        );
        this.dialogRef.close(this.settings);
    }
}
